import React from "react";

const Currency = ({ currency }: { currency: string | null }) => {
    return <span className="montserrat">{currency}</span>;
};

export default Currency;
